import React from "react";
import { cn } from '../../utils/lib/utils';
import PropTypes from 'prop-types';

export function Grid({ 
  className, 
  cols = 1, 
  mdCols, 
  lgCols, 
  gap = 4,
  children,
  ...props 
}) {
  const gapClasses = {
    1: 'gap-1',
    2: 'gap-2',
    3: 'gap-3',
    4: 'gap-4',
    5: 'gap-5',
    6: 'gap-6',
    8: 'gap-8',
    10: 'gap-10',
    12: 'gap-12',
  };

  const colClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
    5: 'grid-cols-5',
    6: 'grid-cols-6',
  };

  return (
    <div
      className={cn(
        'grid',
        gapClasses[gap] || `gap-${gap}`,
        colClasses[cols] || `grid-cols-${cols}`,
        mdCols && (colClasses[mdCols] || `md:grid-cols-${mdCols}`),
        lgCols && (colClasses[lgCols] || `lg:grid-cols-${lgCols}`),
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

Grid.propTypes = {
  className: PropTypes.string,
  cols: PropTypes.number,
  mdCols: PropTypes.number,
  lgCols: PropTypes.number,
  gap: PropTypes.number,
  children: PropTypes.node
};

Grid.displayName = "Grid";
